// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import config from "../config/config";
// import { useParams, useNavigate } from "react-router-dom"; // To get ID and navigate

// const EditStreamForm = () => {
//     const { id } = useParams(); // stream id from URL
//     const navigate = useNavigate();

//     const [colleges, setColleges] = useState([]);
//     const [courses, setCourses] = useState([]);
//     const [selectedCollege, setSelectedCollege] = useState("");
//     const [formData, setFormData] = useState({
//         collegeId: "",
//         courseId: "",
//         courseName: "",
//         streamsName: "",
//         streamsFee: "",
//         applicationDate: "",
//     });

//     // Fetch colleges on mount
//     useEffect(() => {
//         axios
//             .get(`${config.API_BASE_URL}/api/admin/get_collegespage`)
//             .then((res) => setColleges(res.data.collegePages || []))
//             .catch((err) => console.error("Error fetching colleges:", err));
//     }, []);

//     // Fetch existing stream details
//     useEffect(() => {
//         axios
//             .get(`${config.API_BASE_URL}/api/admin/get_streamsbyId/${id}`)
//             .then(async (res) => {
//                 const stream = res.data.getStreamsById;

//                 setFormData({
//                     collegeId: stream.collegeId,
//                     courseId: stream.courseId,
//                     courseName: stream.courseName,
//                     streamsName: stream.streamsName,
//                     streamsFee: stream.streamsFee,
//                     applicationDate: stream.applicationDate?.slice(0, 10), // format for date input
//                 });

//                 setSelectedCollege(stream.collegeId);

//                 // Fetch courses for the college
//                 if (stream.collegeId) {
//                     const courseResponse = await axios.get(`${config.API_BASE_URL}/api/admin/college_page_course_details/${stream.collegeId}`);
//                     setCourses(Array.isArray(courseResponse.data.pageCourseDetails.coursesDeatils) ? courseResponse.data.pageCourseDetails.coursesDeatils : []);
//                 }
//             })
//             .catch((err) => console.error("Error fetching stream:", err));
//     }, [id]);

//     const handleCollegeChange = async (e) => {
//         const collegeId = e.target.value;
//         setSelectedCollege(collegeId);
//         setFormData({ ...formData, collegeId, courseId: "", courseName: "" });

//         try {
//             const response = await axios.get(`${config.API_BASE_URL}/api/admin/college_page_course_details/${collegeId}`);
//             setCourses(Array.isArray(response.data.pageCourseDetails.coursesDeatils) ? response.data.pageCourseDetails.coursesDeatils : []);
//         } catch (error) {
//             console.error("Error fetching courses:", error);
//             setCourses([]);
//         }
//     };

//     const handleCourseChange = (e) => {
//         const courseId = e.target.value;
//         const selectedCourse = courses.find(course => course._id === courseId);
//         setFormData({ ...formData, courseId, courseName: selectedCourse?.courses || "" });
//     };

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData({ ...formData, [name]: value });
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             await axios.put(`${config.API_BASE_URL}/api/admin/update_streams/${id}`, formData);
//             alert("Stream updated successfully!");
//             navigate("/admin/stream"); // Redirect to your streams list page after updating
//         } catch (error) {
//             console.error("Error updating stream:", error);
//         }
//     };

//     return (
//         <div className="container mt-5 pt-5">
//            <div className="row">
//             <div className="col-lg-2"></div>
//             <div className="col-lg-10">
//             <h2 className="mb-4">Edit Stream</h2>
//             <form onSubmit={handleSubmit} className="p-4 border rounded shadow">
//                 <div className="mb-3">
//                     <label className="form-label">Select College:</label>
//                     <select
//                         className="form-control"
//                         name="collegeId"
//                         value={formData.collegeId}
//                         onChange={handleCollegeChange}
//                         required
//                     >
//                         <option value="">Select a college</option>
//                         {colleges.map((college) => (
//                             <option key={college._id} value={college._id}>
//                                 {college.collegeName}
//                             </option>
//                         ))}
//                     </select>
//                 </div>

//                 <div className="mb-3">
//                     <label className="form-label">Select Course:</label>
//                     <select
//                         className="form-control"
//                         name="courseId"
//                         value={formData.courseId}
//                         onChange={handleCourseChange}
//                         required
//                         disabled={!selectedCollege}
//                     >
//                         <option value="">Select a course</option>
//                         {Array.isArray(courses) &&
//                             courses.map((course) => (
//                                 <option key={course._id} value={course._id}>
//                                     {course.courses} - {course.fees}
//                                 </option>
//                             ))}
//                     </select>
//                 </div>

//                 <div className="mb-3">
//                     <label className="form-label">Stream Name:</label>
//                     <input
//                         type="text"
//                         className="form-control"
//                         name="streamsName"
//                         value={formData.streamsName}
//                         onChange={handleChange}
//                         required
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label className="form-label">Stream Fee:</label>
//                     <input
//                         type="text"
//                         className="form-control"
//                         name="streamsFee"
//                         value={formData.streamsFee}
//                         onChange={handleChange}
//                         required
//                     />
//                 </div>

//                 <div className="mb-3">
//                     <label className="form-label">Application Date:</label>
//                     <input
//                         type="date"
//                         className="form-control"
//                         name="applicationDate"
//                         value={formData.applicationDate}
//                         onChange={handleChange}
//                         required
//                     />
//                 </div>

//                 <button type="submit" className="btn btn-success">
//                     Update Stream
//                 </button>
//             </form>
//             </div>
//            </div>
//         </div>
//     );
// };

// export default EditStreamForm;


import React, { useState, useEffect } from "react";
import axios from "axios";
import config from "../config/config";
import { useParams, useNavigate } from "react-router-dom";

const EditStreamForm = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [colleges, setColleges] = useState([]);
    const [courses, setCourses] = useState([]);
    const [selectedCollege, setSelectedCollege] = useState("");

    const [formData, setFormData] = useState({
        collegeId: "",
        courseId: "",
        courseName: "",
        streamsName: "",
        streamsFee: "",
        applicationDate: "",
        para1: "",
        table1: [
            { year: "", tutionFees: ["", ""], semWiseFees: ["", ""], yearlyFees: "" },
        ],
        para2: "",
        table2heading: "",
        table2para: "",
        table2: [
            { year: "", tutionFees: ["", ""], semWiseFees: ["", ""], yearlyFees: "" },
        ],
        cutoffHeading: "",
        cutoffPara: "",
        cutoffTable: [],
        eligibilityCriteriaPara: "",
        courseDetailsPara: "",
    });

    useEffect(() => {
        axios
            .get(`${config.API_BASE_URL}/api/admin/get_collegespage`)
            .then((res) => setColleges(res.data.collegePages || []))
            .catch((err) => console.error("Error fetching colleges:", err));
    }, []);

    useEffect(() => {
        axios
            .get(`${config.API_BASE_URL}/api/admin/get_streamsbyId/${id}`)
            .then(async (res) => {
                const stream = res.data.getStreamsById;

                setFormData({
                    collegeId: stream.collegeId,
                    courseId: stream.courseId,
                    courseName: stream.courseName,
                    streamsName: stream.streamsName,
                    streamsFee: stream.streamsFee,
                    applicationDate: stream.applicationDate?.slice(0, 10),
                    para1: stream.para1 || "",
                    table1: stream.table1 || [],
                    para2: stream.para2 || "",
                    table2heading: stream.table2heading || "",
                    table2para: stream.table2para || "",
                    table2: stream.table2 || [],
                    cutoffHeading: stream.cutoffHeading || "",
                    cutoffPara: stream.cutoffPara || "",
                    cutoffTable: stream.cutoffTable || [],
                    eligibilityCriteriaPara: stream.eligibilityCriteriaPara || "",
                    courseDetailsPara: stream.courseDetailsPara || "",
                });

                setSelectedCollege(stream.collegeId);

                if (stream.collegeId) {
                    const courseResponse = await axios.get(
                        `${config.API_BASE_URL}/api/admin/college_page_course_details/${stream.collegeId}`
                    );
                    setCourses(
                        Array.isArray(courseResponse.data.pageCourseDetails.coursesDeatils)
                            ? courseResponse.data.pageCourseDetails.coursesDeatils
                            : []
                    );
                }
            })
            .catch((err) => console.error("Error fetching stream:", err));
    }, [id]);

    const handleCollegeChange = async (e) => {
        const collegeId = e.target.value;
        setSelectedCollege(collegeId);
        setFormData({ ...formData, collegeId, courseId: "", courseName: "" });

        try {
            const response = await axios.get(
                `${config.API_BASE_URL}/api/admin/college_page_course_details/${collegeId}`
            );
            setCourses(
                Array.isArray(response.data.pageCourseDetails.coursesDeatils)
                    ? response.data.pageCourseDetails.coursesDeatils
                    : []
            );
        } catch (error) {
            console.error("Error fetching courses:", error);
            setCourses([]);
        }
    };

    const handleCourseChange = (e) => {
        const courseId = e.target.value;
        const selectedCourse = courses.find((course) => course._id === courseId);
        setFormData({
            ...formData,
            courseId,
            courseName: selectedCourse?.courses || "",
        });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleDynamicChange = (tableName, rowIndex, fieldName, value, subIndex = null) => {
        const updatedTable = [...formData[tableName]];
        if (subIndex !== null) {
            updatedTable[rowIndex][fieldName][subIndex] = value;
        } else {
            updatedTable[rowIndex][fieldName] = value;
        }
        setFormData({ ...formData, [tableName]: updatedTable });
    };

    const handleAddRow = (tableName, defaultRow) => {
        setFormData({
            ...formData,
            [tableName]: [...formData[tableName], defaultRow],
        });
    };

    const handleRemoveRow = (tableName, index) => {
        const updatedTable = [...formData[tableName]];
        updatedTable.splice(index, 1);
        setFormData({ ...formData, [tableName]: updatedTable });
    };


    // Handlers for table1
    const handleTable1Change = (index, e) => {
        const { name, value } = e.target;
        const updatedTable = [...formData.table1];
        updatedTable[index][name] = value;
        setFormData({ ...formData, table1: updatedTable });
    };

    const addTable1Row = () => {
        setFormData({
            ...formData,
            table1: [
                ...formData.table1,
                { year: "", tutionFees: "", semWiseFees: "", yearlyFees: "" },
            ],
        });
    };

    const removeTable1Row = (index) => {
        const updatedTable = [...formData.table1];
        updatedTable.splice(index, 1);
        setFormData({ ...formData, table1: updatedTable });
    };

    // Handlers for table2
    const handleTable2Change = (index, e) => {
        const { name, value } = e.target;
        const updatedTable = [...formData.table2];
        updatedTable[index][name] = value;
        setFormData({ ...formData, table2: updatedTable });
    };

    const addTable2Row = () => {
        setFormData({
            ...formData,
            table2: [
                ...formData.table2,
                { year: "", tutionFees: "", semWiseFees: "", yearlyFees: "" },
            ],
        });
    };

    const removeTable2Row = (index) => {
        const updatedTable = [...formData.table2];
        updatedTable.splice(index, 1);
        setFormData({ ...formData, table2: updatedTable });
    };

    // Handlers for cutoffTable
    const handleCutoffTableChange = (index, e) => {
        const { name, value } = e.target;
        const updatedTable = [...formData.cutoffTable];
        updatedTable[index][name] = value;
        setFormData({ ...formData, cutoffTable: updatedTable });
    };

    const addCutoffTableRow = () => {
        setFormData({
            ...formData,
            cutoffTable: [
                ...formData.cutoffTable,
                {
                    catregory: "",
                    round1: "",
                    round2: "",
                    round3: "",
                    round4: "",
                    round5: "",
                    round6: "",
                },
            ],
        });
    };

    const removeCutoffTableRow = (index) => {
        const updatedTable = [...formData.cutoffTable];
        updatedTable.splice(index, 1);
        setFormData({ ...formData, cutoffTable: updatedTable });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.put(
                `${config.API_BASE_URL}/api/admin/update_streams/${id}`,
                formData
            );
            alert("Stream updated successfully!");
            navigate("/admin/stream");
        } catch (error) {
            console.error("Error updating stream:", error);
        }
    };

    return (
        <div className="container mt-5 pt-5">
            <div className="row">
                <div className="col-lg-2"></div>
                <div className="col-lg-10">
                    <h2 className="mb-4">Edit Stream</h2>
                    <form onSubmit={handleSubmit} className="p-4 border rounded shadow">
                        {/* Existing fields */}
                        <div className="mb-3">
                            <label className="form-label">Select College:</label>
                            <select
                                className="form-control"
                                name="collegeId"
                                value={formData.collegeId}
                                onChange={handleCollegeChange}
                                required
                            >
                                <option value="">Select a college</option>
                                {colleges.map((college) => (
                                    <option key={college._id} value={college._id}>
                                        {college.collegeName}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Select Course:</label>
                            <select
                                className="form-control"
                                name="courseId"
                                value={formData.courseId}
                                onChange={handleCourseChange}
                                required
                                disabled={!selectedCollege}
                            >
                                <option value="">Select a course</option>
                                {Array.isArray(courses) &&
                                    courses.map((course) => (
                                        <option key={course._id} value={course._id}>
                                            {course.courses} - {course.fees}
                                        </option>
                                    ))}
                            </select>
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Stream Name:</label>
                            <input
                                type="text"
                                className="form-control"
                                name="streamsName"
                                value={formData.streamsName}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Stream Fee:</label>
                            <input
                                type="text"
                                className="form-control"
                                name="streamsFee"
                                value={formData.streamsFee}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Application Date:</label>
                            <input
                                type="date"
                                className="form-control"
                                name="applicationDate"
                                value={formData.applicationDate}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        {/* New fields */}
                        <div className="mb-3">
                            <label className="form-label">Paragraph 1:</label>
                            <textarea
                                className="form-control"
                                name="para1"
                                value={formData.para1}
                                onChange={handleChange}
                            />
                        </div>

                        {/* Table1 */}
                        {/* <div className="mb-3">
                            <label className="form-label">Table 1:</label>
                            {formData.table1.map((entry, index) => (
                                <div key={index} className="mb-2">
                                    <input
                                        type="text"
                                        name="year"
                                        placeholder="Year"
                                        value={entry.year}
                                        onChange={(e) => handleTable1Change(index, e)}
                                    />
                                    <input
                                        type="text"
                                        name="tutionFees"
                                        placeholder="Tuition Fees"
                                        value={entry.tutionFees}
                                        onChange={(e) => handleTable1Change(index, e)}
                                    />
                                    <input
                                        type="text"
                                        name="semWiseFees"
                                        placeholder="Semester-wise Fees"
                                        value={entry.semWiseFees}
                                        onChange={(e) => handleTable1Change(index, e)}
                                    />
                                    <input
                                        type="text"
                                        name="yearlyFees"
                                        placeholder="Yearly Fees"
                                        value={entry.yearlyFees}
                                        onChange={(e) => handleTable1Change(index, e)}
                                    />
                                    <button type="button" onClick={() => removeTable1Row(index)}>Remove</button>
                                </div>
                            ))}
                            <button type="button" onClick={addTable1Row}>Add Row</button>
                        </div> */}
                        <h5>Table 1</h5>
                        {formData.table1.map((row, index) => (
                            <div key={index} className="border p-2 mb-2 rounded">
                                <input
                                    className="form-control mb-1"
                                    placeholder="Year"
                                    value={row.year}
                                    onChange={(e) => handleDynamicChange("table1", index, "year", e.target.value)}
                                    required
                                />
                                {["tutionFees", "semWiseFees"].map((type) => (
                                    <div key={type} className="mb-3">
                                        <label className="form-label d-block">
                                            {type === "tutionFees" ? "Tuition Fees" : "Semester Fees"}
                                        </label>
                                        <div className="row">
                                            {row[type].map((fee, i) => (
                                                <div className="col-md-6 mb-2" key={i}>
                                                    <input
                                                        className="form-control"
                                                        value={fee}
                                                        placeholder={`Entry ${i + 1}`}
                                                        onChange={(e) =>
                                                            handleDynamicChange("table1", index, type, e.target.value, i)
                                                        }
                                                        required
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ))}

                                <input
                                    className="form-control mb-1"
                                    placeholder="Yearly Fees"
                                    value={row.yearlyFees}
                                    onChange={(e) => handleDynamicChange("table1", index, "yearlyFees", e.target.value)}
                                    required
                                />
                                {index > 0 && (
                                    <button
                                        type="button"
                                        onClick={() => handleRemoveRow("table1", index)}
                                        className="btn btn-danger btn-sm"
                                    >
                                        Remove
                                    </button>
                                )}
                            </div>
                        ))}
                        <button
                            type="button"
                            className="btn btn-secondary mb-3"
                            onClick={() =>
                                handleAddRow("table1", {
                                    year: "",
                                    tutionFees: ["", ""],
                                    semWiseFees: ["", ""],
                                    yearlyFees: "",
                                })
                            }
                        >
                            Add Row
                        </button>


                        <div className="mb-3">
                            <label className="form-label">Paragraph 2:</label>
                            <textarea
                                className="form-control"
                                name="para2"
                                value={formData.para2}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Table 2 Heading:</label>
                            <input
                                type="text"
                                className="form-control"
                                name="table2heading"
                                value={formData.table2heading}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Table 2 Paragraph:</label>
                            <textarea
                                className="form-control"
                                name="table2para"
                                value={formData.table2para}
                                onChange={handleChange}
                            />
                        </div>

                        {/* Table2 */}
                        {/* <div className="mb-3">
                            <label className="form-label">Table 2:</label>
                            {formData.table2.map((entry, index) => (
                                <div key={index} className="mb-2">
                                    <input
                                        type="text"
                                        name="year"
                                        placeholder="Year"
                                        value={entry.year}
                                        onChange={(e) => handleTable2Change(index, e)}
                                    />
                                    <input
                                        type="text"
                                        name="tutionFees"
                                        placeholder="Tuition Fees"
                                        value={entry.tutionFees}
                                        onChange={(e) => handleTable2Change(index, e)}
                                    />
                                    <input
                                        type="text"
                                        name="semWiseFees"
                                        placeholder="Semester-wise Fees"
                                        value={entry.semWiseFees}
                                        onChange={(e) => handleTable2Change(index, e)}
                                    />
                                    <input
                                        type="text"
                                        name="yearlyFees"
                                        placeholder="Yearly Fees"
                                        value={entry.yearlyFees}
                                        onChange={(e) => handleTable2Change(index, e)}
                                    />
                                    <button type="button" onClick={() => removeTable2Row(index)}>Remove</button>
                                </div>
                            ))}
                            <button type="button" onClick={addTable2Row}>Add Row</button>
                        </div> */}

                        <h5>Table 2</h5>
                        {formData.table2.map((row, index) => (
                            <div key={index} className="border p-2 mb-2 rounded">
                                <input
                                    className="form-control mb-1"
                                    placeholder="Year"
                                    value={row.year}
                                    onChange={(e) => handleDynamicChange("table2", index, "year", e.target.value)}
                                    required
                                />
                                {["tutionFees", "semWiseFees"].map((type) => (
                                    <div key={type}>
                                        <label>{type === "tutionFees" ? "Tuition Fees" : "Semester Fees"}</label>
                                        {row[type].map((fee, i) => (
                                            <input
                                                key={i}
                                                className="form-control mb-1"
                                                value={fee}
                                                placeholder={`Entry ${i + 1}`}
                                                onChange={(e) => handleDynamicChange("table2", index, type, e.target.value, i)}
                                                required
                                            />
                                        ))}
                                    </div>
                                ))}
                                <input
                                    className="form-control mb-1"
                                    placeholder="Yearly Fees"
                                    value={row.yearlyFees}
                                    onChange={(e) => handleDynamicChange("table2", index, "yearlyFees", e.target.value)}
                                    required
                                />
                                {index > 0 && (
                                    <button
                                        type="button"
                                        onClick={() => handleRemoveRow("table2", index)}
                                        className="btn btn-danger btn-sm"
                                    >
                                        Remove
                                    </button>
                                )}
                            </div>
                        ))}
                        <button
                            type="button"
                            className="btn btn-secondary mb-3"
                            onClick={() =>
                                handleAddRow("table2", {
                                    year: "",
                                    tutionFees: ["", ""],
                                    semWiseFees: ["", ""],
                                    yearlyFees: "",
                                })
                            }
                        >
                            Add Row
                        </button>


                        <div className="mb-3">
                            <label className="form-label">Cutoff Heading:</label>
                            <input
                                type="text"
                                className="form-control"
                                name="cutoffHeading"
                                value={formData.cutoffHeading}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Cutoff Paragraph:</label>
                            <textarea
                                className="form-control"
                                name="cutoffPara"
                                value={formData.cutoffPara}
                                onChange={handleChange}
                            />
                        </div>

                        {/* Cutoff Table */}
                        <div className="mb-3">
                            <label className="form-label">Cutoff Table:</label>
                            {formData.cutoffTable.map((entry, index) => (
                                <div key={index} className="mb-2">
                                    <input
                                        className="form-control mb-1"
                                        type="text"
                                        name="catregory"
                                        placeholder="Category"
                                        value={entry.catregory}
                                        onChange={(e) => handleCutoffTableChange(index, e)}
                                    />
                                    <div className="row px-3">
                                        {["round1", "round2", "round3", "round4", "round5", "round6"].map((round) => (
                                            <input
                                                className="form-control col-2 mb-1"
                                                key={round}
                                                type="text"
                                                name={round}
                                                placeholder={round}
                                                value={entry[round]}
                                                onChange={(e) => handleCutoffTableChange(index, e)}
                                            />
                                        ))}
                                    </div>
                                    <button type="button" className="btn btn-danger mb-3" onClick={() => removeCutoffTableRow(index)}>Remove</button>
                                </div>
                            ))}
                            <button type="button" className="btn btn-secondary mb-3" onClick={addCutoffTableRow}>Add Row</button>
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Eligibility Criteria Paragraph:</label>
                            <textarea
                                className="form-control"
                                name="eligibilityCriteriaPara"
                                value={formData.eligibilityCriteriaPara}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Course Details Paragraph:</label>
                            <textarea
                                className="form-control"
                                name="courseDetailsPara"
                                value={formData.courseDetailsPara}
                                onChange={handleChange}
                            />
                        </div>

                        <button type="submit" className="btn btn-success">Update Stream</button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default EditStreamForm;
